import { Button, Card, Col, List, message, Popconfirm, Row, Spin, Tabs } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { auditService } from '../_services/audit.service';
import Feedback from './components/Feedback';
import FeedbackResult from './components/FeedbackResult';
import { format } from 'rut.js';

const { TabPane } = Tabs;

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const AuditPage = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(urlSearchParams.entries())
  const { auditId, consultationId, department_id } = useParams();
  const [consultation, setConsultation] = useState();
  const [auditConsultation, setAuditConsultation] = useState();
  const [exams, setExams] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [loadingFinish, setLoadingFinish] = useState(false);
  const [loadingDiscard, setLoadingDiscard] = useState(false);
  let query = useQuery();
  const documentType = {
    ce: 'Carnet de extranjería',
    passport: 'Pasaporte'
  }

  const fetchConsultation = async () => {
    setLoading(true);
    try {
      const response = await auditService.consultation({ auditId, consultationId, departmentId: department_id });
      setConsultation(response.data.consultation);
      setAuditConsultation(response.data.audit_consultation);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener las consultas',
        style: {
          marginTop: '45vh',
        },
      })
    } finally {
      setLoading(false);
    }
  }

  const fetchExams = async () => {
    try {
      if (consultation) {
        const response = await auditService.exams({
          consultationId: consultation.consultation_id,
          admissionPatientId: consultation.admission_patient_id
        });
        setExams(response);
      };
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al obtener los examenes',
        style: {
          marginTop: '45vh',
        },
      })
    }
  }

  useEffect(() => {
    fetchConsultation();
  }, [])

  useEffect(() => {
    fetchExams();
  }, [consultation])

  const showFile = async (admissionProcedureResultId) => {
    try {
      const response = await auditService.getProcedureResultFile({ admissionProcedureResultId });
      window.open(response.data.url, '_blank');
    } catch (error) {
      console.error(error)
      message.error({
        content: 'Ocurrió un error al obtener los documentos',
        style: {
          marginTop: '45vh',
        },
      })
    }
  }

  const showDocumentFile = async (id) => {
    try {
      const response = await auditService.getDocumentFile({ objectId: id, objectType: 'ExamsDocument', objectField: 'document' });
      window.open(response.data.document_url, '_blank');
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener los documentos',
        style: {
          marginTop: '45vh',
        },
      })
    }
  }

  const nextConsultation = async () => {
    setLoadingNext(true);
    try {
      const params = {
        auditConsultationId: consultationId,
        auditSessionId: auditId,
        ...(queryParams?.admin_id?.length > 0 && { admin_id: queryParams.admin_id?.split(',') }),
        ...(queryParams?.battery_id?.length > 0 && { battery_id: queryParams.battery_id?.split(',') }),
        ...(queryParams?.branch_office_id?.length > 0 && { branch_office_id: queryParams.branch_office_id?.split(',') }),
        ...(queryParams?.company_id?.length > 0 && { company_id: queryParams.company_id?.split(',') }),
        ...(queryParams?.startDate?.length > 0 && { startDate: queryParams.startDate }),
        ...(queryParams?.endDate?.length > 0 && { endDate: queryParams.endDate }),
        ...(queryParams?.save_admin_id?.length > 0 && { save_admin_id: queryParams.save_admin_id?.split(',') }),
      };
      const response = await auditService.create(params)
      window.location.href = `/auditoria/${department_id}/${response.audit_session_id}/${response.id}?${new URLSearchParams(queryParams).toString()}`;
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ha ocurrido un error al iniciar el proceso de auditoria',
        style: {
          marginTop: '45vh',
        },
      })
    } finally {
      setLoadingNext(false);
    }
  }

  const finishAudit = async () => {
    setLoadingFinish(true);
    try {
      const params = {
        auditConsultationId: consultationId,
        auditSessionId: auditId
      }
      await auditService.finish(params);
      window.location.href = `/`;
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ha ocurrido un error al iniciar el proceso de auditoria',
        style: {
          marginTop: '45vh',
        },
      })
    } finally {
      setLoadingFinish(false);
    }
  }

  const discardAudit = async () => {
    setLoadingDiscard(true);
    try {
      const params = {
        auditConsultationId: consultationId,
        auditSessionId: auditId
      }
      await auditService.discard(params);
      window.location.href = `/`;
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ha ocurrido un error al descartar la auditoria',
        style: {
          marginTop: '45vh',
        },
      })
    } finally {
      setLoadingDiscard(false);
    }
  }

  const approvedStyle = (consultation) => {
    const color = consultation.approved ? '#2F9A81' : '#e74c3c';

    return {
      color: color,
      border: '4px solid',
      borderColor: color,
      padding: 20,
      fontFamily: 'MarkPro',
      fontWeight: 900,
      width: '60%'
    }
  }

  const calculateAge = (birthdate) => {
    return parseInt(moment().diff(birthdate, 'years', true));
  }

  const isAFile = (admissionProcedureResult) => {
    const nameFile = admissionProcedureResult?.object_name.toLowerCase();
    return nameFile.includes('archivo');
  }

  if (loading) {
    return (
      <Spin />
    )
  }

  return (
    <React.Fragment>
      {
        consultation && <Row>
          <Col lg={24}>
            <div style={{ float: 'left' }}>
              <h1>{consultation.battery.name}</h1>
            </div>
            {
              !query.get("view") && <div style={{ float: 'right' }}>
                <Popconfirm
                  title={
                    <div className="audit-page-discard-confirm">
                      <strong>¿Descartar esta auditoría?</strong>
                      <p>No se guardará como auditada y se perderán las observaciones cargadas.</p>
                    </div>
                  }
                  okText="Descartar"
                  cancelText="Cancelar"
                  onConfirm={discardAudit}>
                  <Button className="audit-page-action-button audit-page-discard-button" type="secondary" loading={loadingDiscard} size="large">Descartar</Button>
                </Popconfirm>
                <Button loading={loadingFinish} className="audit-page-action-button" type="primary" size="large" onClick={finishAudit}>Finalizar</Button>
                <Button loading={loadingNext} type="primary" size="large" onClick={nextConsultation}>Siguiente</Button>
              </div>}
          </Col>

          <Col lg={24}>
            <Card title="Paciente">
              <Row gutter={40}>
                <Col lg={12}>
                  <List>
                    <List.Item>
                      {
                        consultation.admission_patient.patient.rut ? (
                          <React.Fragment>
                            {documentType[consultation.admission_patient.patient.document_type]
                              || consultation.admission_patient.patient.document_type.toUpperCase()}:&nbsp;

                            {consultation.admission_patient.patient.document_type === 'rut' ? format(consultation.admission_patient.patient.document_number) : consultation.admission_patient.patient.document_number}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            Pasaporte: {consultation.admission_patient.patient.passport}
                          </React.Fragment>
                        )
                      }
                    </List.Item>
                    <List.Item>
                      Edad: {calculateAge(consultation.admission_patient.patient.birthdate)}
                    </List.Item>
                    <List.Item>
                      Género: {consultation.admission_patient.patient.gender == "0" ? "Masculino" : "Femenino"}
                    </List.Item>
                    <List.Item>
                      Profesión: {consultation.admission_patient.patient.profession}
                    </List.Item>
                    <List.Item>
                      Compañia: {consultation.admission_patient.patient.business_name}
                    </List.Item>
                  </List>
                </Col>
                <Col lg={12}>
                  <h2>
                    Resultado de evaluación
                    <div style={approvedStyle(consultation)}>
                      {consultation.approved
                      ? 'PACIENTE APROBADO' : consultation.revaluation_state === 'expired' ?
                       'CIERRE ADMINISTRATIVO' : 'PACIENTE REPROBADO'}
                    </div>
                    <FeedbackResult auditId={auditId}
                      consultationId={consultationId}
                      auditConsultation={auditConsultation} />
                  </h2>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col lg={24} style={{ marginTop: 40 }}>
            <Card title="Anamnesis">
              <Row gutter={20}>
                <Col lg={12}>
                  {consultation.comment}
                </Col>
                <Col lg={12}>
                  <Feedback auditId={auditId}
                    consultationId={consultationId}
                    auditableId={null}
                    auditableType="comment"
                    view={query.get("view")}
                    auditConsultation={auditConsultation} />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col lg={24} style={{ marginTop: 40 }}>
            <Card title="Exámen Físico">
              <Row gutter={20}>
                <Col lg={12}>
                  {consultation.detail}
                </Col>
                <Col lg={12}>
                  <Feedback auditId={auditId}
                    consultationId={consultationId}
                    auditableId={null}
                    auditableType="detail"
                    view={query.get("view")}
                    auditConsultation={auditConsultation} />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col lg={24} style={{ marginTop: 40 }}>
            <Card title="Conclusión">
              <Row gutter={20}>
                <Col lg={12}>
                  {consultation.conclusion}
                </Col>
                <Col lg={12}>
                  <Feedback auditId={auditId}
                    consultationId={consultationId}
                    auditableId={null}
                    auditableType="conclusion"
                    view={query.get("view")}
                    auditConsultation={auditConsultation} />
                </Col>
              </Row>
            </Card>
          </Col>

          {
            consultation.suggestions && (
              <Col lg={24} style={{ marginTop: 40 }}>
                <Card title="Sugerencias">
                  <Row gutter={20}>
                    <Col lg={12}>
                      {consultation.suggestions}
                    </Col>
                    <Col lg={12}>
                      <Feedback auditId={auditId}
                        consultationId={consultationId}
                        auditableId={null}
                        auditableType="suggestions"
                        view={query.get("view")}
                        auditConsultation={auditConsultation} />
                    </Col>
                  </Row>
                </Card>
              </Col>
            )
          }

          {
            consultation.indications && (
              <Col lg={24} style={{ marginTop: 40 }}>
                <Card title="Indicaciones">
                  <Row gutter={20}>
                    <Col lg={12}>
                      {consultation.indications}
                    </Col>
                    <Col lg={12}>
                      <Feedback auditId={auditId}
                        consultationId={consultationId}
                        auditableId={null}
                        auditableType="indications"
                        view={query.get("view")}
                        auditConsultation={auditConsultation} />
                    </Col>
                  </Row>
                </Card>
              </Col>
            )
          }

          <Col lg={24} style={{ marginTop: 40 }}>
            <Card title="Examenes">
              <Row>
                <Col lg={24}>
                  <Tabs defaultActiveKey="1" tabPosition="left">
                    {
                      exams && exams.map(examItem => {
                        return (
                          <TabPane tab={examItem.name} key={examItem.exam_id}>
                            <Row gutter={40}>
                              <Col lg={12}>
                                <List>
                                  {
                                    examItem.procedure_results && examItem.procedure_results.map(admissionProcedureResult => {
                                      return (
                                        <List.Item>
                                          {
                                            <React.Fragment>
                                              <strong>{admissionProcedureResult.object_name}:</strong> {admissionProcedureResult.result}
                                              {
                                                isAFile(admissionProcedureResult) && <a href="javascript:;" onClick={() => {
                                                  showFile(admissionProcedureResult.id);
                                                }}>
                                                  mostrar archivo
                                                </a>
                                              }
                                            </React.Fragment>
                                          }
                                        </List.Item>
                                      )
                                    })
                                  }

                                  {
                                    examItem.question_results && examItem.question_results.map(admissionQuestionResult => {
                                      return (
                                        <List.Item>
                                          <strong>{admissionQuestionResult.object_name}:</strong> {admissionQuestionResult.result}
                                        </List.Item>
                                      )
                                    })
                                  }

                                  {
                                    examItem.measurement_results && examItem.measurement_results.map(admissionMeasurementResult => {
                                      return (
                                        <List.Item>
                                          <strong>{admissionMeasurementResult.object_name}:</strong> {admissionMeasurementResult.result}
                                        </List.Item>
                                      )
                                    })
                                  }

                                  {
                                    examItem.documents && examItem.documents.map(document => {
                                      return (
                                        <List.Item>
                                          <strong>Documento {document.name}: </strong>
                                          {
                                            <a href="javascript:;" onClick={() => {
                                              showDocumentFile(document.id);
                                            }}>
                                              mostrar documento
                                            </a>
                                          }
                                        </List.Item>
                                      )
                                    })
                                  }
                                </List>
                              </Col>
                              <Col lg={12}>
                                <Feedback
                                  auditId={auditId}
                                  consultationId={consultationId}
                                  auditableType="exam"
                                  auditableId={examItem.exam_id}
                                  view={query.get("view")}
                                  auditConsultation={auditConsultation} />
                              </Col>
                            </Row>
                          </TabPane>
                        )
                      })
                    }
                  </Tabs>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      }
    </React.Fragment >
  )
}

export default AuditPage;